export interface ISurgicalDecline {
    id: number,
    recipientAlias: string,
    recipientBloodType: string,
    recipientAge: number,
    donorAlias: string,
    donorCenterId: number,
    donorCenterAlias: string,
    donorAge: number;
    cPRA: number,
    pmPc: number,
    patientType: string,
    wt: number,
    outcome: string,
    declineDate: string,
    targetSurgeryDate: string,
    status: string,
    reasonUnavailable: string
}


